import React, { memo } from 'react'
import Box from '@/primitives/Box'
import FlexV2 from '@/primitives/FlexV2'
import Icon from '@/primitives/Icon'
import Text from '@/primitives/Text'
import Strings from '@/components/TrialModeView/Strings'

export const ExperimentalBadge = memo(() => {
  const strings = Strings()
  return (
    <Box className='experimental-badge'>
      <Icon name='science' size={200} variant='warning' />
      <Text size={200}>{strings.experimentalFeature}</Text>
    </Box>
  )
})

export const AnimatedMessage = memo(({ message, status }) => (
  <Box className={`animated-message ${status}`}>
    <FlexV2 alignCrossAxis='center' axisGap={200}>
      <Icon name='smart_toy' size={200} variant='primary' />
      <Text>{message}</Text>
    </FlexV2>
  </Box>
))

export const SectionHeader = memo(({ icon, title }) => (
  <FlexV2 alignCrossAxis='center' axisGap={200}>
    <Icon name={icon} size={200} variant='primary' />
    <Text size={200} fontWeight={500}>
      {title}
    </Text>
  </FlexV2>
))
